<template>
  <div class="add-title" ref="add-title">
    <div class="input" :class="{'input-focus':isFocus}">
      <el-input ref="input" :placeholder="icon" v-model="form.title" @focus="isFocus = true" clearable @keyup.enter.native="createTask" maxlength="180"></el-input>
      <div class="btn" v-if="isFocus">
        <div class="btn-in">
          <SelectTime v-model="form.due_date"></SelectTime>
          <SelectColor v-model="form.color_mark"></SelectColor>
        </div>
        <wf-button :disabled="!Boolean(form.title)" @click="createTask" :loading="btnLoading">创建</wf-button>
      </div>
    </div>
  </div>
</template>
<script>
import api from '@/services/api/mine/mine'
import SelectColor from './selectColor'
import SelectTime from './selectTime'
export default {
  components: {
    SelectColor,
    SelectTime
  },
  data() {
    let _this = this
    return {
      form: {
        title: '',
        due_date: null,
        color_mark: null,
        description: '',
        status: 1
      },
      icon: '\ue7c0  添加待办标题，回车即可创建',
      isFocus: false,
      btnLoading: false

    }
  },
  watch: {
    isFocus(val) {
      if (!val) {
        this.form = {
          title: '',
          due_date: null,
          color_mark: '',
          description: '',
          status: 1
        }
        this.btnLoading = false
      }
    }
  },
  mounted() {
    document.addEventListener("click", this.bodyCloseMenus);
  },
  beforeDestroy() {
     document.removeEventListener("click", this.bodyCloseMenus);
  },
  methods: {
    bodyCloseMenus(e) {
      if(!this.isFocus) return
      if (this.$refs['add-title'] && !this.$refs['add-title'].contains(e.target)) {
        if (this.isFocus == true) {
          this.isFocus = false
        }
      }
    },
    clearBox(e) {
      let box = this.$refs['add-title']
      let fl = (e.path || e.composedPath()).find(res => res === box)
      if (!fl && !this.form.title) {
        this.isFocus = false
      }
    },
    async createTask() {
      if (this.form.title === '') return
      this.btnLoading = true
      let result = await api.setTodoTask(this.form)
      this.isFocus = false
      this.$refs.input.blur()
      this.$emit('success', result.id)
    }
  }
}
</script>
<style lang="scss">
.add-title {
  width: 100%;
  box-sizing: border-box;
  .input {
    border-radius: 4px;
    border: 1px solid rgba(32, 32, 32, 0.16);
    min-height: 48px;
    line-height: 48px;
    color: rgba(58, 73, 96, 0.4);
    font-size: 16px;
    width: 100%;
    box-sizing: border-box;
    padding-right: 16px;
    &:hover {
      border: 1px solid rgba(32, 32, 32, 0.6);
    }
    .el-input__inner {
      border: 0 none !important;
      background-color: #f7f8f9;
      font-family: "iconfont";
      font-size: 16px !important;
      padding-right: 40px;
    }
  }
  .input-focus {
    border-color: #2682ff !important;
  }
  .btn {
    margin-left: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .btn-in {
    display: flex;
    align-items: center;
    .btn-box {
      &:hover {
        background-color: #eaebec;
      }
    }
  }
}
</style>
